import { render, staticRenderFns } from "./campus-policies.vue?vue&type=template&id=4b1dbb20&scoped=true&"
import script from "./campus-policies.vue?vue&type=script&lang=js&"
export * from "./campus-policies.vue?vue&type=script&lang=js&"
import style0 from "./campus-policies.vue?vue&type=style&index=0&id=4b1dbb20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1dbb20",
  null
  
)

export default component.exports